/* eslint-env browser */

require('./id7-default-feature-detect');
require('./reflow-event.jquery');
require('./account-popover.jquery');
require('./navigation.jquery');
require('./search-suggest.jquery');
require('./wide-tables.jquery');
require('./koan-spinner.jquery');
require('./jquery-focussable');
require('./site-links');
